/**
 * Flatlogic Dashboards (https://flatlogic.com/admin-dashboards)
 *
 * Copyright © 2015-present Flatlogic, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React, {Suspense} from "react";
import cx from "classnames";
import {Switch} from "react-router";
import {HashRouter} from "react-router-dom";

import s from "./Layout.module.scss";
import Header from "../Header";
import Footer from "../Footer";
import Sidebar from "../Sidebar";
import adminRoutes from "admin/routes";
import PrivateRoute from "admin/_authorize";
import Loading from "admin/components/Loading";

const loading = () => {
  return (
    <div className="loader-container">
      <div className="loader-container-inner">
        <h6 className="mt-3">
          Please wait while we are loading...
          {/* <small>
            Because this is a demonstration we load at once all the Components
            examples. This wouldn't happen in a real live app!
          </small> */}
        </h6>
      </div>
    </div>
  );
};

class Layout extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sidebarOpen: false,
    };
  }

  render() {
    return (
      <div className={s.root}>
        <Loading />
        <Sidebar />
        <div className={cx(s.wrap, {[s.sidebarOpen]: this.state.sidebarOpen})}>
          <Header
            sidebarToggle={() =>
              this.setState({
                sidebarOpen: !this.state.sidebarOpen,
              })
            }
          />
          <main className={s.content + " main-layout"}>
            <Switch>
              {adminRoutes.map((route, idx) => (
                <PrivateRoute {...route} key={idx} />
              ))}
            </Switch>
          </main>
          <Footer />
        </div>
      </div>
    );
  }
}

export default Layout;
